/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Colleague_Map_No_TokenInputs */

const en_colleague_map_no_token = /** @type {(inputs: Colleague_Map_No_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No Mapbox token is configured for this environment.`)
};

const ja_colleague_map_no_token = /** @type {(inputs: Colleague_Map_No_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この環境には Mapbox トークンが設定されていません。`)
};

const fr_colleague_map_no_token = /** @type {(inputs: Colleague_Map_No_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun jeton Mapbox n’est configuré pour cet environnement.`)
};

const de_colleague_map_no_token = /** @type {(inputs: Colleague_Map_No_TokenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für diese Umgebung ist kein Mapbox-Token konfiguriert.`)
};

/**
* | output |
* | --- |
* | "No Mapbox token is configured for this environment." |
*
* @param {Colleague_Map_No_TokenInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const colleague_map_no_token = /** @type {((inputs?: Colleague_Map_No_TokenInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Colleague_Map_No_TokenInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_colleague_map_no_token(inputs)
	if (locale === "ja") return ja_colleague_map_no_token(inputs)
	if (locale === "fr") return fr_colleague_map_no_token(inputs)
	return de_colleague_map_no_token(inputs)
});